// utils
import axios from '../../../utils/axios';

const getSelfRates = async () => {
  try {
    const response = await axios({
      method: 'get',
      url: `/lexus/wallet/api/wallet/rates/getSelf`,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { getSelfRates };
